/**
 * Shared accent color for the broker-connect flow (icon badges, step headings,
 * "Partner" pill). A darker/more muted teal than `colors.success` so it reads
 * as a brand accent rather than a bright "success" green.
 */
export const BROKER_CONNECT_ACCENT = '#0F766E';
